import { createUrl, restPost } from '~/src/dash/api/rest';
import { Order } from '~/src/dash/components/tables/ListViewTable/common';
import { IInventoryRule } from '~/src/dash/apiV2/inventory-rules/inventoryRules';

export interface IAdBreaksQueryParams {
  Search?: string;
  Page: number;
  PageSize: number;
  OrderBy: string;
  OrderDirection: Order;
}

export interface IAdBreak {
  ID: number;
  Name: string;
  AssociatedInventoryRules: number;
  AdBreaks: string;
  InventoryRules: IInventoryRule[] | null;
}

export interface IGetAdBreaksData {
  InvRuleAdbreaksData: IAdBreak[];
  TotalCount: number;
}
export async function getAdBreaksData(
  publisherID: string,
  query: IAdBreaksQueryParams,
  signal?: AbortSignal,
): Promise<IGetAdBreaksData> {
  const reqUrl = `${createUrl('/inv_rule_adbreaks_data/search', publisherID, 'v1')}`;
  const response = await restPost<unknown>(reqUrl, query, undefined, undefined, signal);
  return (
    (response?.parsedBody as IGetAdBreaksData) || {
      InvRuleAdbreaksData: [],
      TotalCount: 0,
    }
  );
}
